// src/pages/yachts/special-offers/components/RatesTimeline.js
import React from 'react';
import moment from 'moment';

function findMatchedRate(rates, dateFrom, dateTo) {
    if (!dateFrom || !dateTo) return null;
    const f = moment(dateFrom);
    const t = moment(dateTo);
    return (
        (rates || []).find(
            (r) =>
                moment(r.date_from).isSameOrBefore(f) &&
                moment(r.date_to).isSameOrAfter(t)
        ) || null
    );
}

function findOverlapping(rates, dateFrom, dateTo) {
    if (!dateFrom || !dateTo) return [];
    const f = moment(dateFrom);
    const t = moment(dateTo);
    return (rates || []).filter(
        (r) =>
            moment(r.date_from).isSameOrBefore(t) &&
            moment(r.date_to).isSameOrAfter(f)
    );
}

const segmentStyle = {
    flex: 1,
    minWidth: 120,
    padding: '8px 12px',
    border: '1px solid #ccd',
    background: '#f7f8fb',
    borderRadius: 4,
    margin: '0 4px'
};

const RatesTimeline = ({ rates, dateFrom, dateTo, onMatch }) => {
    const sorted = (rates || [])
        .slice()
        .sort((a, b) =>
            moment(a.date_from).valueOf() - moment(b.date_from).valueOf()
        );

    const matched = findMatchedRate(sorted, dateFrom, dateTo);

    React.useEffect(() => {
        if (onMatch) onMatch(matched);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matched && matched.id, matched && matched.currency]);
    const overlapping = findOverlapping(sorted, dateFrom, dateTo);

    let caption;
    if (!dateFrom || !dateTo) {
        caption = 'Enter charter window to see which rate period applies.';
    } else if (matched) {
        caption = (
            <>
                Matched rate: {moment(matched.date_from).format('YYYY-MM-DD')} →{' '}
                {moment(matched.date_to).format('YYYY-MM-DD')} — currency:{' '}
                <strong>{(matched.currency || '').toUpperCase()}</strong> — weekly rate:{' '}
                {matched.rate}
            </>
        );
    } else if (overlapping.length > 1) {
        caption = (
            <span className="text-warning">
                Offer spans multiple rate periods — it will not apply at calculate time.
            </span>
        );
    } else {
        caption = (
            <span className="text-warning">
                No rate covers these dates — offer will not apply.
            </span>
        );
    }

    return (
        <div className="rates-timeline" style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', overflowX: 'auto', padding: '8px 0' }}>
                {sorted.length === 0 ? (
                    <em className="text-muted">No rates configured for this yacht.</em>
                ) : (
                    sorted.map((r) => {
                        const isMatched = matched && matched.id === r.id;
                        return (
                            <div
                                key={r.id}
                                style={{
                                    ...segmentStyle,
                                    borderColor: isMatched ? '#0a7' : '#ccd',
                                    background: isMatched ? '#e7faf2' : '#f7f8fb'
                                }}
                            >
                                <div>
                                    <strong>
                                        {moment(r.date_from).format('MMM D, YYYY')}
                                    </strong>{' '}
                                    →{' '}
                                    <strong>
                                        {moment(r.date_to).format('MMM D, YYYY')}
                                    </strong>
                                </div>
                                <div>
                                    {(r.currency || '').toUpperCase()} {r.rate}/wk
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
            <div style={{ fontSize: 13, color: '#41506e' }}>{caption}</div>
        </div>
    );
};

export default RatesTimeline;
